module.exports = __webpack_public_path__ + "img/0050.bfd54d6e.png";